declare global {
  interface String {
    toEnglishDigits(): string;
    toLocaleString(): string;
    toNumber(): number;
    toNumberString(): string;
    formatStringNumber(): string;
  }
}

const persianCharCode = 1728;
const arabicCharCode = 1632;

const persianNumbersRegex = /[\u06F0-\u06F9]/g;
const arabicNumbersRegex = /[\u0660-\u0669]/g;

String.prototype.toEnglishDigits = function () {
  return this.replace(persianNumbersRegex, (match) =>
    String.fromCharCode(match.charCodeAt(0) - persianCharCode),
  ).replace(arabicNumbersRegex, (match) =>
    String.fromCharCode(match.charCodeAt(0) - arabicCharCode),
  );
};

String.prototype.toLocaleString = function () {
  return Number(this.replace(/[^0-9.]/g, "")).toLocale();
};

String.prototype.toNumber = function () {
  return Number(this.toEnglishDigits()?.replace(/[^0-9.]/g, ""));
};

String.prototype.toNumberString = function () {
  return this.replace(/[^0-9.]/g, "");
};

String.prototype.formatStringNumber = function () {
  const num = +this;
  if (typeof num === "number") {
    return num.toLocale(0, 6);
  } else {
    return "-";
  }
};

export {};
